const app = {
    showFileSize(fileObj){
        if (fileObj) {
            const szByte= parseInt(fileObj.size);
            const decimals = 2;
            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    
            const i = Math.floor(Math.log(szByte) / Math.log(k))
    
            return `${parseFloat((szByte / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        } else {
            return '';
        }
    }
}
export default app;
